import { ArtCondition, ArtPurchaseCondition } from './constants';
import typeHints from './typeHints';

const attributes = {

  art_artist_name: {
    friendly: 'Artist',
    validations: {
      maxLength: 200,
    },
  },

  art_media: {
    friendly: 'Media',
    validations: {
      maxLength: 150,
    },
  },

  art_year_produced: {
    friendly: 'Year Produced',
    validations: {
      maxLength: 150,
    },
  },

  art_edition: {
    friendly: 'Edition',
    validations: {
      maxLength: 255,
    },
  },

  art_country_of_origin: {
    friendly: 'Country Of Origin',
    validations: {
      maxLength: 150,
    },
  },

  art_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: ArtCondition,
    },
  },

  art_medium: {
    friendly: 'Medium',
    validations: {
      maxLength: 255,
    },
  },

  art_dimentions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 255,
    },
  },

  art_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 255,
    },
  },

  art_frame: {
    friendly: 'Frame',
    validations: {
      maxLength: 255,
    },
  },

  art_subject: {
    friendly: 'Subject',
    validations: {
      maxLength: 255,
    },
  },

  art_colors: {
    friendly: 'Colors',
    validations: {
      maxLength: 255,
    },
  },

  art_period: {
    friendly: 'Period',
    validations: {
      maxLength: 255,
    },
  },

  art_movement: {
    friendly: 'Style/Movement',
    validations: {
      maxLength: 255,
    },
  },

  art_signature: {
    friendly: 'Signature',
    validations: {
      maxLength: 255,
    },
  },

  art_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: ArtPurchaseCondition,
    },
  },

  art_artist_bibliography: {
    friendly: 'Bibliography',
    validations: {
      maxLength: 32000,
    },
    typeHint: typeHints.TextArea,
  },

  art_artist_cv: {
    friendly: 'Artist CV',
    validations: {
      maxLength: 32000,
    },
  },

  art_artist_awards: {
    friendly: 'Artist Awards',
    validations: {
      maxLength: 32000,
    },
  },

  art_ownership_history: {
    friendly: 'Ownership History',
    validations: {
      maxLength: 32000,
    },
    typeHint: typeHints.TextArea,
  },

  art_exhibition_history: {
    friendly: 'Exhibition History',
    validations: {
      maxLength: 32000,
    },
    typeHint: typeHints.TextArea,
  },

  art_conservation_history: {
    friendly: 'Conservation History',
    validations: {
      maxLength: 32000,
    },
    typeHint: typeHints.TextArea,
  },

  art_catalogue_raisonne: {
    friendly: 'Catalogue Raisonne',
    validations: {
      maxLength: 32000,
    },
    typeHint: typeHints.TextArea,
  },

  art_literature: {
    friendly: 'Literature',
    validations: {
      maxLength: 32000,
    },
    typeHint: typeHints.TextArea,
  },

  art_conservation_contact: {
    friendly: 'Conservation Contact',
    validations: {
      type: 'foreignKey',
    },
    typeHint: typeHints.Contact,
  },

  art_conservation_type: {
    friendly: 'Conservation Type',
    validations: {
      maxLength: 255,
    },
  },

  art_conservation_start_date: {
    friendly: 'Start Date',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  art_conservation_end_date: {
    friendly: 'End Date',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  art_conservation_cost: {
    friendly: 'Conservation Cost',
    validations: {
      type: 'decimal',
    },
    typeHint: typeHints.Monetary,
  },

  art_conservation_notes: {
    friendly: 'Conservation Notes',
    validations: {
      maxLength: 32000,
    },
    typeHint: typeHints.TextArea,
  },

};

export default attributes;

export const ArtDefaultSplitAttribute = 'art_artist_name';

export const ArtRequiredAttributes = [];

export const ArtItemSearchAttributes = ['art_artist_name', 'art_media', 'art_year_produced'];

export const ArtOverviewAttributes = ['title', 'art_artist_name', 'art_media', 'art_year_produced', 'art_edition', 'art_country_of_origin', 'art_condition',
  'market_value', 'inventory_no', 'tags'];

export const ArtSpecificationAttributes = ['art_medium', 'art_dimentions', 'art_weight', 'art_frame', 'art_subject', 'art_colors', 'art_period', 'art_movement',
  'art_signature'];

export const ArtPurchaseAttributes = ['purchase_date', 'purchase_price', 'art_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const ArtDetailAttributes = ['art_artist_bibliography', 'art_artist_cv', 'art_artist_awards'];

export const ArtDisplayAttributes = ['art_artist_name', 'art_media', 'art_medium', 'art_dimentions', 'tags'];

export const ArtSliderGalleryAttributes = {
  titleKey: 'art_artist_name',
  subtitleKey: 'art_media',
};



// WEBPACK FOOTER //
// ./src/config/artDataAttributes.js